module.exports = __webpack_public_path__ + "img/pickawood-gf8e6XvG_3E-unsplash.1fa4eedb.jpg";